// MIT License - Copyright (c) 2026 Doug McNall

/**
 * Mass Effect Universe - Aliens Configuration
 */

export const MassEffectAliensPlanets = {
  planets: {
    1700: ['asari', 'turian', 'salarian', 'krogan', 'quarian'],  // Citadel - all species
    1701: ['batarian', 'krogan', 'turian', 'asari'],             // Omega - criminals
    1702: ['asari'],                                              // Thessia - asari homeworld
    1703: ['turian'],                                             // Palaven - turian homeworld
    1704: ['salarian'],                                           // Sur'Kesh - salarian homeworld
    1705: ['krogan'],                                             // Tuchanka - krogan homeworld
    1706: ['quarian', 'geth'],                                    // Rannoch - quarian/geth
    1707: ['asari', 'hanar', 'elcor', 'volus'],                  // Illium - diverse colony
    1708: ['salarian', 'asari'],                                  // Noveria - research
    1709: ['collector', 'reaper'],                                // Ilos - Prothean ruins
    1710: ['geth', 'krogan'],                                     // Virmire - Saren's base
    1711: ['asari', 'salarian']                                   // Feros - colony
  },
  randomEncounters: ['geth', 'collector', 'batarian'],
  hostileSpecies: ['geth', 'collector', 'reaper', 'batarian'],
  friendlyTraders: ['asari', 'turian', 'salarian', 'hanar', 'elcor', 'volus']
};

export default MassEffectAliensPlanets;
